import M from 'moment'
import API from './Api'
import * as R from 'ramda'

import React from 'react'
import {HttpStatus} from "../components/common/Constants";

export const isNotNilAndEmpty = (...data) => R.all(R.complement(R.either(R.isNil, R.isEmpty)), data);
export const hasNilOrEmpty = (...data) => R.any(R.either(R.isNil, R.isEmpty), data);

export const fetchAsync = async (asyncFn, setError, menuName, ...args) => {
    try {
        let res = await asyncFn(...args);
        if (res.ok) {
            if (res.data.status === HttpStatus.FAILED) {
                setError({
                    menuName,
                    errorMessage: res.data.message,
                });
            }
        }

        return res;
    } catch (error) {
        console.error("Error:", error);
        setError({
            menuName,
            errorMessage: "An unexpected error occurred.",
        });
    }
};

export const fetchDataAsync = async ({asyncFn, setError, menuName, args = {}}) => {
    try {
        let res = await asyncFn(args);
        if (res.ok && res.data.status === HttpStatus.FAILED && res.data.code === 503) {
            setError({
                menuName,
                errorMessage: res.data.message,
            });
        }
        return res;
    } catch (error) {
        console.error("Error:", error);
        setError({
            menuName,
            errorMessage: "An unexpected error occurred.",
        });
    }
};

export const checkAndHandleError = (res, setError, menuName) => {
    if (res.data.code === 503) {
        handleError(setError, menuName, res.data.message);
        return true;
    }
    return false;
};

const handleError = (setError, menuName, message) => {
    setError({
        menuName,
        errorMessage: message,
    });
};

export const base64ToFile = (base64String, fileName, mimeType) => {
    if (base64String === null || base64String === undefined) {
        return null;
    }

    const byteCharacters = atob(base64String.split(',')[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    return new File([byteArray], fileName, {type: mimeType});
}

export const contructQueryParam = (params) => {
    if (Object.keys(params).length === 0) {
        return "";
    }

    const queryString = Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    return `?${queryString}`;
}

export const getUserAccess = (menuAccess, selectedCabang) => {
    let res = menuAccess.filter(item => item.idRefObj === selectedCabang)
    return res.length > 0 ? res[0] : null;
}

export const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        if (!file) {
            reject(new Error("No file provided"));
            return;
        }

        const fileReader = new FileReader();

        fileReader.onload = () => {
            resolve(fileReader.result); // Base64 string
        };

        fileReader.onerror = () => {
            reject(new Error("Failed to read file"));
        };

        fileReader.readAsDataURL(file);
    });
};

export const FormatRupiah = ({number}) => {
    const formattedNumber = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0, // No decimals
    }).format(number);

    return <span>{formattedNumber}</span>;
};

export const FormatCurrencyWithoutSymbol = ({number}) => {
    if (isNaN(number)) {
        return "Invalid number";
    }

    const formattedNumber = new Intl.NumberFormat('id-ID', {
        useGrouping: true,
    }).format(number);

    return formattedNumber;
}

export const FormatCurrencyRupiah = ({number}) => {
    if (isNaN(number) || number === undefined) {
        number = 0;
    }

    const formattedNumber = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
    }).format(number);

    return formattedNumber;
}

export const FormatCurrencyRupiahTwoDigitsDecimal = ({number}) => {
    if (isNaN(number) || number === undefined) {
        number = 0;
    }

    const formattedNumber = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 2,
    }).format(number);

    return formattedNumber;
}

export function parseApplicantData(payload) {
    let {
        applicantBirthDate,
        applicantGender,
        applicantNationality,
        applicantReligion,
        applicantMaritalStatus,
        applicantEducationLevel,
        applicantRecruitmentRequestDTO,
        applicantBloodType,
        applicantClothSize,
        applicantFamilies,
        applicantFormalEducations,
        applicantInformalEducations,
        applicantLanguageSkills,
        applicantSpecialAbilities,
        applicantWeaknesss,
        applicantReferences,
        applicantDocuments,
        applicantSocialMedias
    } = payload

    let dataLanguageSkill = Object.assign([], applicantLanguageSkills)
    dataLanguageSkill = dataLanguageSkill.map((value, index) => {
        return {
            ...value,
            conversationLanguageSkillCompetencyType: value.conversationLanguageSkillCompetencyType.bizparKey,
            languageSkill: value.languageSkill.bizparKey,
            listeningLanguageSkillCompetencyType: value.listeningLanguageSkillCompetencyType.bizparKey,
            readingLanguageSkillCompetencyType: value.readingLanguageSkillCompetencyType.bizparKey,
            writingLanguageSkillCompetencyType: value.writingLanguageSkillCompetencyType.bizparKey,
        }
    })

    let dataSocialMedia = Object.assign([], applicantSocialMedias)
    dataSocialMedia = dataSocialMedia.map((value, index) => {
        return {
            ...value,
            socialMediaType: value.socialMediaType.bizparKey
        }
    })

    let dataAbility = Object.assign([], applicantSpecialAbilities)
    dataAbility = dataAbility.map((value, index) => {
        return {
            ...value,
            specialAbilityCompetencyType: value.specialAbilityCompetencyType.bizparKey
        }
    })

    let dataDeficiency = Object.assign([], applicantWeaknesss)
    dataDeficiency = dataDeficiency.map((value, index) => {
        return {
            ...value,
            weaknessCategory: value.weaknessCategory.bizparKey,
            weaknessType: value.weaknessType.bizparKey
        }
    })

    let dataReference = Object.assign([], applicantReferences)
    dataReference = dataReference.map((value, index) => {
        return {
            ...value,
            referenceType: value.referenceType.bizparKey
        }
    })
    let dataDocument = Object.assign([], applicantDocuments)
    dataDocument = dataDocument.map((value, index) => {
        return {
            ...value,
            documentType: value.documentType.bizparKey
        }
    })
    let dataInformalEdu = Object.assign([], applicantInformalEducations)
    dataInformalEdu = dataInformalEdu.map((value, index) => {
        return {
            ...value,
            informalEducationTrainingType: value.informalEducationTrainingType.bizparKey,
            informalEducationCostSource: value.informalEducationCostSource.bizparKey
        }
    })
    let dataFormalEdu = Object.assign([], applicantFormalEducations)
    dataFormalEdu = dataFormalEdu.map((value, index) => {
        return {
            ...value,
            formalEducationDegree: value.formalEducationDegree.bizparKey,
            formalEducationDegreePosition: value.formalEducationDegreePosition.bizparKey,
            formalEducationDepartement: value.formalEducationDepartement.bizparKey,
            formalEducationInstitute: !R.isNil(value.formalEducationInstitute) ? value.formalEducationInstitute.instituteID : "",
            formalEducationType: value.formalEducationType.bizparKey,
            formalEducationLevel: value.formalEducationLevel.bizparKey
        }
    })

    let dataFamily = Object.assign([], applicantFamilies)
    dataFamily = dataFamily.map((value, index) => {
        return {
            ...value,
            familyEducationLevel: value.familyEducationLevel.bizparKey,
            familyGenderType: value.familyGenderType.bizparKey,
            familyMaritalStatus: value.familyMaritalStatus.bizparKey,
            familyNationalityType: value.familyNationalityType.bizparKey,
            familyRelationshipType: value.familyRelationshipType.bizparKey,
            familyReligionType: value.familyReligionType.bizparKey,
            familyType: value.familyType.bizparKey,
            applicantFamilyAddress: {
                address: value.applicantFamilyAddress.address.map((data, index) => {
                    return {
                        ...data,
                        country: data.country.countryID,
                        addressType: data.addressType.bizparKey,
                        province: data.province.provinceID,
                        kabkot: data.kabkot.kabkotID,
                        kelurahan: data.kelurahan.kelurahanID,
                        kecamatan: data.kecamatan.kecamatanID
                    }
                })
            }
        }
    })

    payload = {
        ...payload,
        "applicantBirthDate": applicantBirthDate === M(applicantBirthDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? applicantBirthDate : M(applicantBirthDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        "applicantGender": applicantGender.bizparKey,
        "applicantNationality": applicantNationality.bizparKey,
        "applicantReligion": applicantReligion.bizparKey,
        "applicantMaritalStatus": applicantMaritalStatus.bizparKey,
        "applicantEducationLevel": applicantEducationLevel ? applicantEducationLevel.bizparKey : '',
        "recruitmentRequestID": applicantRecruitmentRequestDTO.recruitmentRequestID,
        "applicantBloodType": applicantBloodType.bizparKey,
        "applicantClothSize": applicantClothSize.bizparKey,
        "applicantFamilies": dataFamily,
        "applicantFormalEducations": dataFormalEdu,
        "applicantInformalEducations": dataInformalEdu,
        "applicantLanguageSkills": dataLanguageSkill,
        "applicantSpecialAbilities": dataAbility,
        "applicantWeaknesss": dataDeficiency,
        "applicantReferences": dataReference,
        "applicantDocuments": dataDocument,
        "applicantSocialMedias": dataSocialMedia,
        "updatedBy": "SYSTEM",
        "updatedDate": M().format("DD-MM-YYYY HH:mm:ss")
    }

    delete payload.applicantRecruitmentRequestDTO
    delete payload.applicantCreatedAt
    delete payload.applicantModifiedAt
    delete payload.applicantModifiedBy
    return payload
}

export function parseCncData(payload) {
    let {cncTPLData} = payload

    let dataHeader = Object.assign([], cncTPLData.header.components)
    dataHeader = dataHeader.map((value) => {
        return {
            ...value,
            cncHeaderSectionItemComponent: value.cncHeaderSectionItemComponent.bizparKey
        }
    })

    let dataFeedback = Object.assign([], cncTPLData.contentSection.feebackSection.feedbackItems)
    dataFeedback = dataFeedback.map((value) => {
        return {
            ...value,
            feedbackType: value.feedbackType.bizparKey,
        }
    })

    let dataImprove = Object.assign([], cncTPLData.contentSection.feebackSection.improveTargetItems)
    dataImprove = dataImprove.map((value) => {
        return {
            ...value,
            improveTargetItemCategory: value.improveTargetItemCategory.bizparKey,
            improveTargetItems: value.improveTargetItems.map((data) => {
                return {
                    ...data,
                    improveTargetComponent: data.improveTargetComponent.bizparKey
                }
            })
        }
    })

    let dataArea = Object.assign([], cncTPLData.contentSection.areaDevelopmentSection.items)
    dataArea = dataArea.map((value) => {
        return {
            ...value,
            areaDevelopmentSectionItemCategory: value.areaDevelopmentSectionItemCategory.bizparKey,
            areaDevelopmentSectionItems: value.areaDevelopmentSectionItems.map((data) => {
                return {
                    ...data,
                    areaDevelopmentSectionSubItemComponent: data.areaDevelopmentSectionSubItemComponent.bizparKey
                }
            })
        }
    })

    let dataSignage = Object.assign([], cncTPLData.signageSections.cncSignageSectionItems)
    dataSignage = dataSignage.map((value) => {
        return {
            ...value,
            cncSignageSectionItemCategory: value.cncSignageSectionItemCategory.bizparKey,
            cncSignageSectionItems: value.cncSignageSectionItems.map((data) => {
                return {
                    ...data,
                    cncSignageSectionSubItemComponent: data.cncSignageSectionSubItemComponent.bizparKey
                }
            })
        }
    })

    payload = {
        ...payload,
        cncTPLData: {
            ...payload.cncTPLData,
            header: {
                ...payload.cncTPLData.header,
                components: dataHeader
            },
            contentSection: {
                ...payload.cncTPLData.contentSection,
                feebackSection: {
                    ...payload.cncTPLData.contentSection.feebackSection,
                    feedbackItems: dataFeedback,
                    improveTargetItems: dataImprove
                },
                areaDevelopmentSection: {
                    items: dataArea
                }
            },
            signageSections: {
                ...payload.cncTPLData.signageSections,
                cncSignageSectionItems: dataSignage
            }
        }
    }
    return payload
}

export async function getBizpar(cat) {
    let resCount = await API.create('BIZPAR').getCountBizparByCategory(cat)
    let payload = {
        params: {
            bizparCategory: cat
        },
        offset: 0,
        limit: R.isNil(resCount.data) || R.isNil(resCount.data.data) ? 5 : resCount.data.data
    }

    let response = await API.create('BIZPAR').getBizparByCategory(payload)
    // console.log('GET BIZPAR ' + cat + ' > ', response)
    if (response.data && response.data.status === "S") {
        return response.data.data
    } else {
        return []
    }
}

export function convertMonths(month) {
    let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    return monthNames[month - 1]
}

export function renderInputText(label, value, onChange, readonly = false) {
    return (
        <div className="margin-bottom-15px">
            <div className="margin-5px">
                <span className="txt-site txt-11 txt-main txt-bold">
                    {label}
                </span>
            </div>

            <input
                readOnly={readonly}
                style={{
                    backgroundColor: readonly ? "#E6E6E6" : "white"
                }}
                value={value}
                onChange={onChange}
                className="txt txt-sekunder-color"
                type="text"
                placeholder=""
            />
        </div>
    )
}

export function renderSelectBox(label, placeholder, value, bizpar, onChange) {
    return (
        <div className="margin-bottom-15px">
            <div className="margin-5px">
                {label && (
                    <span className="txt-site txt-11 txt-main txt-bold">
                        {label}<span style={{color: "red"}}>*</span>
                    </span>
                )}
            </div>
            <select value={value} onChange={onChange} className="cf-select slc slc-sekunder">
                <option value=""> -- please select {placeholder} --</option>
                {bizpar.map((data, index) => {
                    return (<option key={index} value={data.bizparKey}>{data.bizparValue}</option>)
                })}
            </select>
        </div>
    )
}

export function parseEmployeeData(data, type) {
    let {
        employeeBirthDate,
        employeeDateOfDeath,
        employeeRegistrationDate,
        employeeExitDate,
        employeePartnerDeathDate,
        employeeDivorceDate,
        employeePPHEndDate,
        employeeGender,
        employeeEthnicGroup,
        employeeNationality,
        applicant,
        employeeGrade,
        employeeReligion,
        employeeEducationLevel,
        employeeBloodType,
        employeeClothSize,
        employeeStatus,
        employeeType,
        employeeMaritalStatus,
        employeeWorkingLocation,
        employeeFamilies,
        employeeFormalEducations,
        employeeInformalEducations,
        employeeLanguageSkills,
        employeeAddresses,
        employeeSpecialAbilities,
        employeeWeaknesses,
        employeeReferences,
        employeeDocuments,
        employeeWorkExperiences,
        employeeLicenses,
        employeeSocialMedias,
        employeeAppreciations,
        employeeInsurances,
        employeeFacilities,
        employeeGlassesSpecs,
        employeeLegalDocuments,
        employeeTaxDocuments,
        employeePTKPType,
        employeePension,
        employeePaymentMethods,
        employeeShio,
        employeeElement,
        employeeUnsur,
        recordID,
        position,
        company,
    } = data

    let dataLanguageSkill = Object.assign([], employeeLanguageSkills)
    dataLanguageSkill = dataLanguageSkill.map((value, index) => {
        return {
            ...value,
            conversationLanguageSkillCompetencyType: value.conversationLanguageSkillCompetencyType.bizparKey,
            languageSkill: value.languageSkill.bizparKey,
            listeningLanguageSkillCompetencyType: value.listeningLanguageSkillCompetencyType.bizparKey,
            readingLanguageSkillCompetencyType: value.readingLanguageSkillCompetencyType.bizparKey,
            writingLanguageSkillCompetencyType: value.writingLanguageSkillCompetencyType.bizparKey,
            languageSkillType: value.languageSkillType ? value.languageSkillType.bizparKey : ''
        }
    })

    let dataSocialMedia = Object.assign([], employeeSocialMedias)
    dataSocialMedia = dataSocialMedia.map((value, index) => {
        return {
            ...value,
            socialMediaType: value.socialMediaType.bizparKey
        }
    })

    let dataLicense = Object.assign([], employeeLicenses)
    dataLicense = dataLicense.map((value, index) => {
        return {
            ...value,
            employeeLicenseType: value.employeeLicenseType.bizparKey
        }
    })

    let dataAbility = Object.assign([], employeeSpecialAbilities)
    dataAbility = dataAbility.map((value, index) => {
        return {
            ...value,
            specialAbilityCompetencyType: value.specialAbilityCompetencyType.bizparKey
        }
    })

    let dataDeficiency = Object.assign([], employeeWeaknesses)
    dataDeficiency = dataDeficiency.map((value, index) => {
        return {
            ...value,
            weaknessCategory: value.weaknessCategory.bizparKey,
            weaknessType: value.weaknessType.bizparKey
        }
    })

    let dataReference = Object.assign([], employeeReferences)
    dataReference = dataReference.map((value, index) => {
        return {
            ...value,
            referenceType: value.referenceType.bizparKey
        }
    })
    let dataDocument = Object.assign([], employeeDocuments)
    dataDocument = dataDocument.map((value, index) => {
        return {
            ...value,
            documentType: value.documentType.bizparKey
        }
    })
    let dataWorkEx = Object.assign([], employeeWorkExperiences)
    dataWorkEx = dataWorkEx.map((value, index) => {
        return {
            ...value,
            employeeWorkExperienceType: value.employeeWorkExperienceType && value.employeeWorkExperienceType.bizparKey
        }
    })
    let dataInformalEdu = Object.assign([], employeeInformalEducations)
    dataInformalEdu = dataInformalEdu.map((value, index) => {
        return {
            ...value,
            informalEducationNameForCertificate: value.informalEducationNameForCertificate ? value.informalEducationNameForCertificate.bizparValue : "",
            informalEducationTrainingType: value.informalEducationTrainingType ? value.informalEducationTrainingType.bizparKey : "",
            informalEducationCostSource: value.informalEducationCostSource ? value.informalEducationCostSource.bizparKey : ""
        }
    })
    let dataFormalEdu = Object.assign([], employeeFormalEducations)
    dataFormalEdu = dataFormalEdu.map((value, index) => {
        return {
            ...value,
            formalEducationDegree: value.formalEducationDegree ? value.formalEducationDegree.bizparKey : "",
            formalEducationDegreePosition: value.formalEducationDegreePosition ? value.formalEducationDegreePosition.bizparKey : "",
            formalEducationDepartment: value.formalEducationDepartment ? value.formalEducationDepartment.bizparKey : "",
            formalEducationInstitute: value.formalEducationInstitute ? value.formalEducationInstitute.instituteID : "",
            formalEducationType: value.formalEducationType ? value.formalEducationType.bizparKey : "",
            formalEducationLevel: value.formalEducationLevel ? value.formalEducationLevel.bizparKey : "",
            formalEducationCostSource: value.formalEducationCostSource ? value.formalEducationCostSource.bizparKey : "",
        }
    })

    let dataFamily = Object.assign([], employeeFamilies)
    dataFamily = dataFamily.map((value, index) => {
        return {
            ...value,
            familyEducationLevel: value.familyEducationLevel.bizparKey,
            familyGenderType: value.familyGenderType && value.familyGenderType.bizparKey,
            familyMaritalStatus: value.familyMaritalStatus.bizparKey,
            familyNationalityType: value.familyNationalityType && value.familyNationalityType.bizparKey,
            familyRelationshipType: value.familyRelationshipType.bizparKey,
            familyReligionType: value.familyReligionType.bizparKey,
            familyType: value.familyType.bizparKey,
            familyFaskes: value.familyFaskes.bizparKey,
            familyFaskesClass: value.familyFaskesClass.bizparKey,
            familyBloodType: value.familyBloodType ? value.familyBloodType.bizparKey : '',
            employeeFamilyAddress: {
                address: value.employeeFamilyAddress.address.map((data, index) => {
                    return {
                        ...data,
                        country: data.country && typeof data.country === 'object' ? data.country.countryID : data.country,
                        addressType: data.addressType && typeof data.addressType === 'object' ? data.addressType.bizparKey : data.addressType,
                        province: data.province && typeof data.province === 'object' ? data.province.provinceID : data.province,
                        kabkot: data.kabkot && typeof data.kabkot === 'object' ? data.kabkot.kabkotID : data.kabkot,
                        kelurahan: data.kelurahan && typeof data.kelurahan === 'object' ? data.kelurahan.kelurahanID : data.kelurahan,
                        kecamatan: data.kecamatan && typeof data.kecamatan === 'object' ? data.kecamatan.kecamatanID : data.kecamatan
                    }
                })
            }
        }
    })

    let dataAppreciation = Object.assign([], employeeAppreciations)
    dataAppreciation = dataAppreciation.map((value, index) => {
        return {
            ...value,
            appreciationType: value.appreciationType.bizparKey
        }
    })

    let dataInsurances = Object.assign([], employeeInsurances)
    dataInsurances = dataInsurances.map((value, index) => {
        return {
            ...value,
            insuranceCategory: value.insuranceCategory.bizparKey,
            insuranceType: value.insuranceType.bizparKey,
            insuranceFaskesClass: !R.isNil(value.insuranceFaskesClass) ? value.insuranceFaskesClass.bizparKey : value.insuranceFaskesClass,
            insuranceFaskesType: !R.isNil(value.insuranceFaskesType) ? value.insuranceFaskesType.bizparKey : value.insuranceFaskesType,
        }
    })

    let dataPayMethods = Object.assign([], employeePaymentMethods)
    dataPayMethods = dataPayMethods.map((value) => {
        return {
            ...value,
            employeePaymentMethod: value.employeePaymentMethod ? value.employeePaymentMethod.bizparKey : "",
            employeePaymentShareMethod: value.employeePaymentShareMethod ? value.employeePaymentShareMethod.bizparKey : "",
            employeeCaseType: value.employeeCaseType ? value.employeeCaseType.bizparKey : "",
            employeePaymentBankID: value.employeePaymentBankID ? value.employeePaymentBankID.bankID : "",
            employeePaymentCurrency: value.employeePaymentCurrency ? value.employeePaymentCurrency.bizparKey : "",
            employeeTHRBase: value.employeeTHRBase ? value.employeeTHRBase.bizparKey : ""
        }
    })

    let dataFacility = Object.assign([], employeeFacilities)
    dataFacility = dataFacility.map((value, index) => {
        return {
            ...value,
            facilityCategory: value.facilityCategory.bizparKey,
            facilityType: value.facilityType.bizparKey
        }
    })

    let dataGlassesSpecs = Object.assign([], employeeGlassesSpecs)
    dataGlassesSpecs = dataGlassesSpecs.map((value, index) => {
        return {
            ...value,
            glassesSpecType: value.glassesSpecType.bizparKey,
        }
    })

    let dataLegalDoc = Object.assign([], employeeLegalDocuments)
    dataLegalDoc = dataLegalDoc.map((value, index) => {
        return {
            employeeLegalDocumentID: value.employeeLegalDocumentID,
            legalDocumentNo: value.legalDocumentNo,
            legalDocumentDate: value.legalDocumentDate,
            legalDocumentStartDate: value.legalDocumentStartDate,
            legalDocumentEndDate: value.legalDocumentEndDate,
            legalDocumentGrade: value.legalDocumentGrade,
            legalDocumentURL: value.legalDocumentURL,
            esid: value.companyID,
            ouid: value.positionID
        }
    })

    let dataTaxDoc = Object.assign([], employeeTaxDocuments)
    dataTaxDoc = dataTaxDoc.map((value, index) => {
        return {
            employeeTaxDocumentID: value.employeeTaxDocumentID,
            taxDocumentNo: value.taxDocumentNo,
            taxDocumentDate: value.taxDocumentDate,
            taxDocumentStartMonth: value.taxDocumentStartMonth,
            taxDocumentEndMonth: value.taxDocumentEndMonth,
            taxDocumentURL: value.taxDocumentURL,
            esid: value.companyID
        }
    })

    let dataAddreeses = Object.assign([], employeeAddresses)
    dataAddreeses = dataAddreeses.map((value, index) => {
        return {
            ...value,
            country: value.country !== null ? typeof value.country === 'object' ? value.country.countryID : value.country : '',
            addressType: value.addressType !== null ? typeof value.addressType === 'object' ? value.addressType.bizparKey : value.addressType : '',
            province: value.province !== null ? typeof value.province === 'object' ? value.province.provinceID : value.province : '',
            kabkot: value.kabkot !== null ? typeof value.kabkot === 'object' ? value.kabkot.kabkotID : value.kabkot : '',
            kecamatan: value.kecamatan !== null ? typeof value.kecamatan === 'object' ? value.kecamatan.kecamatanID : value.kecamatan : '',
            kelurahan: value.kelurahan !== null ? typeof value.kelurahan === 'object' ? value.kelurahan.kelurahanID : value.kelurahan : ''
        }
    })

    let dataApplicant = applicant && applicant.applicantNumber ? applicant.applicantNumber : ""
    let dataOuid = position.positionID
    let dataEsid = company.companyID

    data = {
        ...data,
        recruitmentRequestID: data.recruitmentRequestID && data.recruitmentRequestID.recruitmentRequestID,
        employeeRegistrationDate: employeeRegistrationDate === M(employeeRegistrationDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeeRegistrationDate : M(employeeRegistrationDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeeBirthDate: employeeBirthDate === M(employeeBirthDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeeBirthDate : M(employeeBirthDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeeDateOfDeath: employeeDateOfDeath === M(employeeDateOfDeath, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeeDateOfDeath : employeeDateOfDeath === "Invalid date" || R.isEmpty(employeeDateOfDeath) || R.isNil(employeeDateOfDeath) ? "" : M(employeeDateOfDeath, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeePPHEndDate: employeePPHEndDate === M(employeePPHEndDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeePPHEndDate : employeePPHEndDate === "Invalid date" || R.isEmpty(employeePPHEndDate) || R.isNil(employeePPHEndDate) ? "" : M(employeePPHEndDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeeExitDate: employeeExitDate === M(employeeExitDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeeExitDate : employeeExitDate === "Invalid date" || R.isEmpty(employeeExitDate) || R.isNil(employeeExitDate) ? "" : M(employeeExitDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeePartnerDeathDate: employeePartnerDeathDate === M(employeePartnerDeathDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeePartnerDeathDate : employeePartnerDeathDate === "Invalid date" || R.isEmpty(employeePartnerDeathDate) || R.isNil(employeePartnerDeathDate) ? "" : M(employeePartnerDeathDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeeDivorceDate: employeeDivorceDate === M(employeeDivorceDate, "DD-MM-YYYY").format("DD-MM-YYYY") ? employeeDivorceDate : employeeDivorceDate === "Invalid date" || R.isEmpty(employeeDivorceDate) || R.isNil(employeeDivorceDate) ? "" : M(employeeDivorceDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
        employeeGender: employeeGender === null ? employeeGender : employeeGender.bizparKey,
        employeeEthnicGroup: employeeEthnicGroup === null ? employeeEthnicGroup : employeeEthnicGroup.bizparKey,
        employeeNationality: employeeNationality === null ? employeeNationality : employeeNationality.bizparKey,
        applicantID: dataApplicant,
        employeeReligion: employeeReligion.bizparKey,
        employeeGrade: !R.isNil(employeeGrade) ? employeeGrade.bizparKey : '',
        employeeEducationLevel: employeeEducationLevel.bizparKey,
        employeeBloodType: employeeBloodType.bizparKey,
        employeeClothSize: employeeClothSize.bizparKey,
        employeeStatus: employeeStatus.bizparKey,
        employeeType: employeeType.bizparKey,
        employeeMaritalStatus: employeeMaritalStatus.bizparKey,
        employeeWorkingLocation: employeeWorkingLocation ? employeeWorkingLocation.companyID : '',
        employeeFamilies: dataFamily,
        employeeWorkExperiences: dataWorkEx,
        employeeFormalEducations: dataFormalEdu,
        employeeInformalEducations: dataInformalEdu,
        employeeLanguageSkills: dataLanguageSkill,
        employeeSpecialAbilities: dataAbility,
        employeeWeaknesses: dataDeficiency,
        employeeReferences: dataReference,
        employeeSocialMedias: dataSocialMedia,
        employeeDocuments: dataDocument,
        employeeLicenses: dataLicense,
        employeeAppreciations: dataAppreciation,
        employeeInsurances: dataInsurances,
        employeeFacilities: dataFacility,
        employeeAddress: dataAddreeses,
        employeeGlassesSpecs: dataGlassesSpecs,
        employeeLegalDocuments: dataLegalDoc,
        employeeTaxDocuments: dataTaxDoc,
        employeePTKPType: !R.isNil(employeePTKPType) ? employeePTKPType.bizparKey : employeePTKPType,
        employeePension: {
            ...employeePension,
            employeePensionType: employeePension.employeePensionType ? employeePension.employeePensionType.bizparKey : ""
        },
        employeePaymentMethods: dataPayMethods,
        employeeShio: !R.isNil(employeeShio) ? employeeShio.bizparKey : employeeShio,
        employeeElement: !R.isNil(employeeElement) ? employeeElement.bizparKey : employeeElement,
        employeeUnsur: !R.isNil(employeeUnsur) ? employeeUnsur.bizparKey : employeeUnsur,
        recordID: recordID,
        updatedBy: "SYSTEM",
        updatedDate: M().format("DD-MM-YYYY HH:mm:ss"),
        ouid: dataOuid,
        esid: dataEsid
    }

    delete data.applicant
    delete data.position
    delete data.company
    delete data.employeeAddresses
    type !== 'biodata' && delete data.employeeAddress
    delete data.employeeCreationalDTO

    return data
}

export function checkColorIconStatus(val) {
    let colors = val === "INITIATE" ? "orange" : val === "APPROVED" || val === "APPROVE" ? "brown" : val === "" || val === null ? null : val === "REJECTED" ? "#424242" : "gray"
    return colors
}

export function checkResponseError(res, type) {
    if (res.status === 502 || res.status === 503) {
        alert('The site is currently under maintenance. We should be back shortly. Thank you for your patience.')
    } else if (res.status === 504) {
        alert('Oops, connection time out!')
    } else {
        if (type === 'report') {
            if (res.size <= 0) {
                return alert("Data Not Found")
            } else if (res.status !== 200) {
                return alert('Report Not Found')
            }
        } else {
            R.isNil(res.data) || R.isNil(res.data.message) || R.isEmpty(res.data.message) || res.data.message === "null" ? alert('Oops, something went wrong message null!') : alert("Failed: " + res && res.data && res.data.message)
        }
    }
    return res
}

export function checkFormatDoc(res) {
    let type = res.type && res.type
    if (String(type).includes('ms-excel')) {
        res = '.xls'
    } else if (String(type).includes('spreadsheetml')) {
        res = '.xlsx'
    } else if (String(type).includes('csv')) {
        res = '.csv'
    } else {
        res = ''
    }
    return res
}

export function formatNpwp(value) {
    if (typeof value === 'string') {
        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6');
    }
}

export function nonFormatNpwp(value) {
    if (typeof value === 'string') {
        return value.replace(/\D/g, '');
    }
}

export function formatNominal(nominal) {
    const reverse = nominal.toString().split('').reverse().join('');
    const ribuan = reverse.match(/\d{1,3}/g);
    const hasil = ribuan.join('.').split('').reverse().join('');
    return hasil;
};

export function formatNominalMinus(nominal) {
    const reverse = nominal.toString().split('').reverse().join('');
    const ribuan = reverse.match(/\d{1,3}/g);
    let hasil = ribuan.join('.').split('').reverse().join('');
    if (nominal < 0) {
        hasil = "-" + hasil;
    }
    return hasil;
};

export function onlyNumber(value) {
    if (typeof value === 'string') {
        return value.replace(/\D/g, '');
    }
}

export function formatRp(num, fixed = 0) {
    if (!num) return 0
    num = parseFloat(num);
    var p = num.toFixed(fixed).split('.');
    return (
        // 'Rp ' +
        p[0]
            .split('')
            .reverse()
            .reduce(function (acc, num, i, orig) {
                return num == '-' ? acc : num + (i && !(i % 3) ? '.' : '') + acc;
            }, '') +
        ((p[1] == null) ? '' : ',' + p[1])
    );
}

export function formatEmail(email) {
    if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email)) return true
    else return false
}

export function wildcardToRegex(pattern) {
      const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regexPattern = escaped.replace(/%/g, '.*');
      return new RegExp(`^${regexPattern}$`, 'i');
}